import { render, staticRenderFns } from "./ContactRequestsTab.vue?vue&type=template&id=b3ecfd70"
import script from "./ContactRequestsTab.vue?vue&type=script&lang=js"
export * from "./ContactRequestsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports